<header class="header">
  <app-navbar
    [startPageUrl]="startPageUrl"
    [showPauseActionWithinTask]="true"
    logoUrl="assets/logo.svg"
  />
</header>
